<nb-card>
  <nb-card-header>
    Teaminformationen
  </nb-card-header>
  <nb-card-body *ngIf="team() as team">
    <div class="detail-body">
      <div class="left">
        <div>
          <label class="label">Teamname</label>
          <span>{{ team.name }}</span>
        </div>
        <div>
          <label class="label">Teamleiter</label>
          <span>{{ team.leader.fullName }}</span>
        </div>
        <div>
          <label class="label">Anzahl der Teammitglieder</label>
          <span>{{ team.userCount }}</span>
        </div>
        <div>
          <label class="label">Fläche</label>
          <span>{{ team.totalArea | number:'1.2-2' }} m²</span>
        </div>
      </div>
      <div class="right">
        <div>
          <label class="label">Teamkürzel</label>
          <span>{{ team.abbreviation }}</span>
        </div>
        <div>
          <label class="label">Dienstleister</label>
          <span>{{ team.tenant.name }}</span>
        </div>
        <div>
          <label class="label">Region</label>
          <span *ngIf="team.region != null" >{{ team.region }}</span>
          <span *ngIf="team.region == null">Keiner Region zugewiesen</span>
        </div>
        <div class="flex-grow"></div>
        <button nbButton fullWidth status="basic" (click)="editTeam(team)">
          <span>Team bearbeiten</span>
          <nb-icon icon="external-link-outline" pack="eva"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
